/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIAgentsObservabilitySummaryResponse {
    getFixupPrototypeFunction() { return AIAgentsObservabilitySummaryResponse.fixupPrototype; }

    static newInstance(model: Partial<AIAgentsObservabilitySummaryResponse>): AIAgentsObservabilitySummaryResponse {
        let obj = Object.assign(new AIAgentsObservabilitySummaryResponse(), model);
        AIAgentsObservabilitySummaryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIAgentsObservabilitySummaryResponse>): AIAgentsObservabilitySummaryResponse {
        if (!model) return null;
        return AIAgentsObservabilitySummaryResponse.newInstance(<AIAgentsObservabilitySummaryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIAgentsObservabilitySummaryResponse) {
        if (!obj) return;

        models.AIAgentsObservabilitySummaryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIAgentsObservabilitySummaryResponse): boolean {
        Object.setPrototypeOf(obj, AIAgentsObservabilitySummaryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.agents) {
            for (let val of this.agents) {
                models.AIAgentSummary.fixupPrototype(val);
            }
        }
    }

    /**
     * Agents with their summary metrics
     */
    agents: Array<models.AIAgentSummary>;

}
